import {
  backendOptionsSchema,
  type ForkTemplateSchema,
  forkTemplateSchema,
  scriptTemplateSchema,
} from "@gearbox-protocol/deploy-tools-shared";
import { kvArrayToRecord, kvSchema, recordToKVArray } from "utils";
import { z } from "zod";

export const scriptSchema = scriptTemplateSchema
  .extend({
    env: z.array(kvSchema).optional(),
  })
  .superRefine((script, ctx) => {
    const hasNpx = !!script.npx;
    const hasDocker = !!script.docker;
    if (hasNpx === hasDocker) {
      // attach to both fields so the error shows on whichever one is rendered
      for (const path of ["npx", "docker"] as const) {
        ctx.addIssue({
          code: "custom",
          message: "exactly one of npx or docker must be specified",
          path: [path],
        });
      }
    }
  });

export type ScriptSchema = z.infer<typeof scriptSchema>;

export const backendSchema = backendOptionsSchema.extend({
  env: z.array(kvSchema).optional(),
});

export type BackendSchema = z.infer<typeof backendSchema>;

export const forkSchema = forkTemplateSchema.extend({
  scripts: z.array(scriptSchema).nullish(),
  backend: backendSchema.optional(),
});

export type ForkSchema = z.infer<typeof forkSchema>;

export function toForkTemplate(data: ForkSchema): ForkTemplateSchema {
  return {
    ...data,
    scripts: data.scripts?.length
      ? data.scripts.map(script => ({
          ...script,
          env: kvArrayToRecord(script.env),
        }))
      : undefined,
    backend: data.backend
      ? { ...data.backend, env: kvArrayToRecord(data.backend.env) }
      : undefined,
  };
}

export function fromForkTemplate(data: ForkTemplateSchema): ForkSchema {
  return {
    ...data,
    scripts: data.scripts
      ? data.scripts.map(script => ({
          ...script,
          env: recordToKVArray(script.env),
        }))
      : [],
    backend: data.backend
      ? { ...data.backend, env: recordToKVArray(data.backend.env) }
      : undefined,
  };
}
